import KnowledgeItemsView from '@/views/KnowledgeItemsDetailView.vue';
import FormView from '@/views/FormView.vue';

export default {
  routes: {
    'knowledge-items': KnowledgeItemsView,
    'catalog-forms': FormView,
  },
};
